import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, Typography, Grid } from "../../components/ui";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";

// Recursive Tree Node Component

const data = {
  familyId: 42,
  zone: "North Wing",
  tree: {
    id: 1,
    name: "John Doe",
    profile: { bio: "..." /* etc */ },
    marriages: [{ role: "husband", spouse: { id: 2, name: "Jane Doe" } }],
    children: [
      {
        relation: "son",
        node: {
          id: 3,
          name: "Alex Doe",
          profile: {
            /* ... */
          },
          marriages: [],
          children: [],
        },
      },
      {
        relation: "daughter",
        node: {
          id: 4,
          name: "Emily Doe",
          profile: {
            /* ... */
          },
          marriages: [],
          children: [],
        },
      },
    ],
  },
};

const TreeNode = ({ person, relation }: { person: any; relation?: string }) => {
  if (!person) return null;

  return (
    <Box sx={{ ml: 4, mt: 2 }}>
      <Card sx={{ minWidth: 200, backgroundColor: "#f5f5f5" }}>
        <CardContent>
          {relation && (
            <Typography variant="caption" color="text.secondary">
              Relation: {relation}
            </Typography>
          )}
          <Typography variant="h6">{person?.name}</Typography>
          {person.profile && (
            <>
              <Typography variant="body2">
                {/* You can display profile details here */}
                Gender : {person?.profile?.gender}
              </Typography>
              <Typography variant="body2">
                {/* You can display profile details here */}
                DOB : {person?.profile?.date_of_birth}
              </Typography>
            </>
          )}
          {/* {person.marriages?.length > 0 && (
            <Typography variant="body2" color="text.secondary">
              Marriages: {person?.marriages?.length}
            </Typography>
          )} */}
          {person.marriages?.length > 0 && (
            <Box mt={1}>
              <Typography variant="subtitle2">Spouse(s):</Typography>
              {person.marriages.map((marriage: any, idx: number) => (
                <Box key={idx} ml={2} mt={0.5}>
                  <Typography variant="body2">Role: {marriage.role}</Typography>
                  <Typography variant="body2">
                    Name: {marriage.spouse?.name}
                  </Typography>
                  {marriage.spouse?.profile && (
                    <>
                      <Typography variant="body2">
                        Gender: {marriage.spouse.profile.gender}
                      </Typography>
                      <Typography variant="body2">
                        DOB: {marriage.spouse.profile.date_of_birth}
                      </Typography>
                    </>
                  )}
                </Box>
              ))}
            </Box>
          )}
        </CardContent>
      </Card>

      {/* Render Children */}
      {person.children?.map((child: any, index: number) => (
        <TreeNode key={index} person={child?.node} relation={child?.relation} />
      ))}
    </Box>
  );
};

const FamilyTree = () => {
  const { state } = useLocation();
  const [familyData, setFamilyData] = useState<any>();
  console.log(state, "===================");

  const handleGetFamily = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/family/${state?.id}`);
      if (resp?.status === 200) {
        setFamilyData(resp?.data?.data?.tree);
      }
    } catch (error: any) {
      toast.error(error);
    }
  };

  useEffect(() => {
    handleGetFamily();
  }, []);

  return (
    // <Box sx={{ p: 2 }}>
    //   <Typography variant="h4" gutterBottom>
    //     Family Tree
    //   </Typography>
    //   <TreeNode person={familyData} />
    // </Box>
    <Grid container p={2} px={{ md: 10, xs: 5 }}>
      <Grid size={12}>
        <Button onClick={() => {}} sx={{ textTransform: "none" }}>
          <Typography fontSize={20} fontWeight={500} color="#111827">
            Family Tree
            {/* <IconButton onClick={handleOpen}>
                <Add sx={{ color: "#111827" }} />
              </IconButton> */}
          </Typography>
        </Button>
      </Grid>
      <Grid size={12} mt={2} py={1}>
        <TreeNode person={familyData} />
      </Grid>
    </Grid>
  );
};

export default FamilyTree;
